module.exports = __webpack_public_path__ + "img/event_users.2c9913ec.svg";